import { Form, Input } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FormulaCodeField: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item name="code" label={t('global:code')}>
      <Input placeholder={t('global:code')} />
    </Form.Item>
  )
}

export default FormulaCodeField
